import { configureStore, createAction, createListenerMiddleware } from '@reduxjs/toolkit';
//import loginReducer from '../features/loginSlice';
import searchSliceReducer from '../features/searchSlice';
import clickContextReducer from '../features/clickContextSlice';
import loadDataReducer from '../features/CareCenterDataSlice';
import filterReducer from '../features/filterSlice';
import activeMarkersReducer from '../features/activeMarkers'
import {profileApi }from '../features/profilesSlice';
import userAttributesReducer from '../features/userAttributesSlice'
import dialogReducer from '../features/dialogSlice'
import {utilityApi }from '../features/utilitySlice';
import { surveyApi } from '../features/surveysSlice';
//import { chatscopeApi } from '../features/chatScopeSlice';
import { chatscopeApi } from '../features/useChatSlice';
import dataProcessingSliceReducer from '../features/dataProcessingSlice';
import { chatApi } from '../features/ChatSlice';
import { institutionsApi } from '../features/institutionsSlice';
import { aiAnalyticsApi } from '../features/aiAnalytics';
import { resourcesApi, lazyResouceCompanionReducer  } from '../features/resourcesSlice';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { clinicalTrialssApi } from '../features/clinicalTrials';
import { oidcApi } from '../features/oidcSlice';
import userTokenManagementReducer from '../features/userTokenManagementSlice';
import { adminApi } from '../features/adminSlice';
import { utilityReducer } from '../features/utilitySlice'
import { aiMatcherApi } from '../poc/bcan_clinical_trials/trial_recommendation'; //BCAN TRIAL
import { healthWalletApi, clearVerificationReducer } from '../components/healthwallet/healthWalletSlice';
//import { onboardingApi } from '../components/healthwallet/onboardingSlice'; // Moved to healthWalletSlice
//import { chrApi } from '../features/surveysSlice';

// export const listenerMiddleware = createListenerMiddleware();
// // actions.ts


// export const markMessageRead = createAction<{ messageId: number; userId: number }>('messages/markRead');
// listenerMiddleware.startListening({
//   actionCreator: markMessageRead,
//   effect: async (action, { dispatch }) => {
//     try {
//       const result = await store.dispatch(
//         //chatscopeApi.endpoints.setReadMessage.initiate({          messageId: action.payload.messageId,          userId: action.payload.userId,        })
//         chatscopeApi.endpoints.setReadConversation.initiate({          conversationId: 272,          userId: action.payload.userId,        }, { track: true } )
//       ).unwrap();
//       console.log('Backend response:', result);
//     } catch (err) {
//       console.error('setReadMessage failed:', err);
//     }
//   },
// });
export const store = configureStore({
  reducer: {
    [surveyApi.reducerPath]: surveyApi.reducer,
    [chatscopeApi.reducerPath]: chatscopeApi.reducer,
    search: searchSliceReducer,
    dataProcessing: dataProcessingSliceReducer,
    clickcontext: clickContextReducer,
    loaddata: loadDataReducer,
    filter: filterReducer,
    activeMarkers: activeMarkersReducer, 
    [utilityApi.reducerPath]: utilityApi.reducer,
    [profileApi.reducerPath]: profileApi.reducer,
    [chatApi.reducerPath]: chatApi.reducer,
    //chatCount: chatCount.reducer,
    [institutionsApi.reducerPath]: institutionsApi.reducer,
    [clinicalTrialssApi.reducerPath]: clinicalTrialssApi.reducer,
    [aiAnalyticsApi.reducerPath]: aiAnalyticsApi.reducer,
    [resourcesApi.reducerPath]: resourcesApi.reducer,
    [oidcApi.reducerPath]: oidcApi.reducer,
    userattributes: userAttributesReducer,
    dialog: dialogReducer,
    lazyResouceCompanion: lazyResouceCompanionReducer,
    userTokenManagement: userTokenManagementReducer,
    utility: utilityReducer,
    
    [adminApi.reducerPath]: adminApi.reducer,
    [aiMatcherApi.reducerPath]: aiMatcherApi.reducer, //BCAN TRIAL
    [healthWalletApi.reducerPath]: healthWalletApi.reducer,
    clearVerification: clearVerificationReducer,
    // [onboardingApi.reducerPath]: onboardingApi.reducer, // Moved to healthWalletSlice
  },
  middleware: getDefaultMiddleware =>
  getDefaultMiddleware()
  .concat(oidcApi.middleware)
  .concat(profileApi.middleware)
  .concat(aiAnalyticsApi.middleware)
  .concat(chatApi.middleware)
  .concat(surveyApi.middleware)
  .concat(chatscopeApi.middleware)//, listenerMiddleware.middleware)
  .concat(utilityApi.middleware)
  .concat(institutionsApi.middleware)
  .concat(resourcesApi.middleware)
  .concat(clinicalTrialssApi.middleware)
  .concat(adminApi.middleware)
  .concat(aiMatcherApi.middleware) //BCAN TRIAL
  .concat(healthWalletApi.middleware)
  // .concat(onboardingApi.middleware), // Moved to healthWalletSlice
});
// export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
// // Infer the `RootState` and `AppDispatch` types from the store itself
 export type RootState = ReturnType<typeof store.getState>
 export type AppDispatch = typeof store.dispatch
// Use this for dispatching actions (e.g., const dispatch = useAppDispatch();)
// It is automatically typed to know all your possible actions.
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();

// 🛑 Renamed to match your preferred 'useTypedSelector' convention.
// This is automatically typed to know the structure of your RootState.
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector.withTypes<RootState>();
